export default {
      id: "team-building-usage",
      viewBox: "0 0 71 71",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#team-building",
      toString: function () {
        return this.url;
      }
    }